import { render, staticRenderFns } from "./register-myinfo-verify-detail.vue?vue&type=template&id=a84b6958&"
import script from "./register-myinfo-verify-detail.vue?vue&type=script&lang=js&"
export * from "./register-myinfo-verify-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports